import { formatCurrency, getSHA256Hash } from "@habity/utils";
import {
  getCategoryText,
  getLivingSpace,
  getPlotSize,
  getRooms,
} from "./addresses";
import { NestedSearch, NestedSearchWithObjects, TODO } from "@habity/types";
import { formatDistance } from "date-fns";
import { sv } from "date-fns/locale";
import { PERSONAS } from "@habity/constants";
import { formatLocation } from "./searches";

export const formatBuyerSearchingFor = (search?: NestedSearchWithObjects, areaName?: string) => {
  if (!search) return "Letar efter bostad";

  const {
    municipalities,
    areas,
    categories,
    persona
  } = search || {};

  const personaItem = PERSONAS?.find((p) => p.key === persona);

  const data: string[] = [];

  if (categories) data.push(categories.map((c: TODO) => getCategoryText(c)).join(", "));

  if (data.length === 0) return "Letar efter bostad";

  // Build up different parts of the buyer text

  const personaText = personaItem ? `${personaItem.title} som letar` : "Letar";

  const categoriesText = categories
    ?.map((c: TODO) => getCategoryText(c))
    .join(", ")
    .toLowerCase();

  const locationText = areaName || formatLocation(areas, municipalities) || 'hela Sverige';

  const timeDiffText = formatDistance(
    new Date(),
    new Date(search.created_at),
    {
      addSuffix: false,
      locale: sv,
    },
  );

  return `${personaText} ${categoriesText} i ${locationText} sedan ${timeDiffText}`;
};

export const formatBuyerData = (search?: NestedSearch) => {
  if (!search) return "Letar efter bostad";
  const {
    monthly_fee_min,
    monthly_fee_max,
    living_space_min,
    living_space_max,
    rooms_min,
    rooms_max,
    price_min,
    price_max,
    plot_size_min,
    plot_size_max,
    categories,
  } = search;
  const data: string[] = [];
  // if (categories)
  //   data.push(categories.map((c: TODO) => getCategoryText(c)).join(", "));

  if (rooms_min && rooms_max) data.push(`${rooms_min}-${getRooms(rooms_max)}`);
  if (rooms_min && !rooms_max) data.push(`från ${getRooms(rooms_min)}`);
  if (rooms_max && !rooms_min) data.push(`till ${getRooms(rooms_max)}`);

  if (living_space_min && living_space_max)
    data.push(`${living_space_min}-${getLivingSpace(living_space_max)}`);
  if (living_space_min && !living_space_max)
    data.push(`från ${getLivingSpace(living_space_min)}`);
  if (living_space_max && !living_space_min)
    data.push(`till ${getLivingSpace(living_space_max)}`);

  if (plot_size_min && plot_size_max)
    data.push(`${plot_size_min}-${getPlotSize(plot_size_max)}`);
  if (plot_size_min && !plot_size_max)
    data.push(`från ${getPlotSize(plot_size_min)}`);
  if (plot_size_max && !plot_size_min)
    data.push(`till ${getPlotSize(plot_size_max)}`);

  if (price_min && price_max)
    data.push(`${formatCurrency(price_min)}-${formatCurrency(price_max)}`);
  if (price_min && !price_max) data.push(`minst ${formatCurrency(price_min)}`);
  if (price_max && !price_min) data.push(`max ${formatCurrency(price_max)}`);

  if (monthly_fee_min && monthly_fee_max)
    data.push(
      `${formatCurrency(monthly_fee_min)}-${formatCurrency(monthly_fee_max)}`,
    );
  if (monthly_fee_min && !monthly_fee_max)
    data.push(`minst ${formatCurrency(monthly_fee_min)}`);
  if (monthly_fee_max && !monthly_fee_min)
    data.push(`max ${formatCurrency(monthly_fee_max)}`);

  // if (category) data.push(getCategoryText(category));
  // if (rooms) data.push(getRooms(rooms));
  // if (living_space) data.push(getLivingSpace(living_space, additional_space));
  // if (plot_size) data.push(getPlotSize(plot_size));
  // if (monthly_fee) data.push(getMonthlyFee(monthly_fee));
  if (data.length === 0) return "Letar efter bostad";
  return data.join(" • ");
};

export const getAvatarUrl = async (email: string) => {
  const hash = await getSHA256Hash(email);

  return `https://gravatar.com/avatar/${hash}?d=https://encrypted-tbn0.gstatic.com/images?q=https://app.habity.co/storage/v1/object/public/assets/images/pixel.png?t=2024-09-19T19%3A24%3A26.375Z`;
};
